import React, { useCallback } from "react";
import { ReactSVG } from "react-svg";
import { ChipIcon } from "@picklebet/ui";

type CategoryIconProps = {
  iconUrl?: string;
  size?: number;
  className?: string;
};

const CategoryIcon = ({ iconUrl, size = 24, className }: CategoryIconProps) => {
  const fallback = useCallback(
    () => (
      <ChipIcon
        width={size}
        height={size}
        aria-hidden
        focusable={false}
        className={className}
      />
    ),
    [size, className],
  );

  const beforeInjection = useCallback(
    (svg: SVGElement) => {
      svg.setAttribute("width", `${size}`);
      svg.setAttribute("height", `${size}`);
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
    },
    [size],
  );

  if (!iconUrl) {
    return fallback();
  }

  return (
    <ReactSVG
      src={iconUrl}
      className={className}
      fallback={fallback}
      beforeInjection={beforeInjection}
    />
  );
};

export { CategoryIcon };
